import Box from "@mui/material/Box";
import ExportExcel from "./ExcelExport";

function DisplayExport({ excelData, fileName }) {
  //This is the flex item
  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "5%",
        maxHeight: "100px",
        Height: "100px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <ExportExcel excelData={excelData} fileName={fileName} />
    </Box>
  );
}

export default DisplayExport;
